import NoteTextPreview from './NoteTextPreviewContainer';

export default NoteTextPreview;